import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { push } from 'react-router-redux';
import { TextField, TextFieldHelperText } from 'rmwc';

import * as styles from '../../styles';
import Tree from '../tree';
import { request } from '../../containers/actions';
import { setSelectedItems } from '../tree/actions';
import * as actions from './actions';
import { host_v2 } from '../../utilities/requests';


const cellphoneValidator = /^[0۰][9۹][\d۰-۹]{9}$/;
const cellphonePartialValidator = cellphoneValidator.toPartialMatchRegex();

export default class Info extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        cellphoneValidator,
        representivates:null
    }

    cityTreeFilterSelector = createSelector(
        [() => this.props.store.getIn(['regionTree', 'selected'])],
        regions => ({
            region: regions.keySeq().join(',') || -1,
        }),
    )

    componentDidMount() {
        this.fetch.bind(this)();
        this.fetchRepresentivate();
    }

    componentWillReceiveProps(nextProps) {
        if (
            !_.isEqual(
                nextProps.store.getIn(['regionTree', 'selected']).keySeq().toArray(),
                this.props.store.getIn(['regionTree', 'selected']).keySeq().toArray(),
            ) &&
            _.isEqual(
                nextProps.store.getIn(['cityTree', 'selected']).keySeq().toArray(),
                this.props.store.getIn(['cityTree', 'selected']).keySeq().toArray(),
            )
        ) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'city',
                this.props.store.getIn(['cityTree', 'elementId']),
            ));
        }
        // if (
        //     nextProps.store.getIn(['cityTree', 'selected']) !== this.props.store.getIn(['cityTree', 'selected']) ||
        //     nextProps.store.getIn(['regionTree', 'selected']) !== this.props.store.getIn(['regionTree', 'selected'])
        // )
        //     this.setState({address: ''});
        
    }

    async fetchRepresentivate(){
        const url = host_v2 + '/api/StoreApi/GetRepresentative';
         const res = await fetch(url);

         const data = await res.json();
         if(data?.errorId === 0)
            this.setState(el=>({...el, representivates: data.result}))
    }

    async fetch() {
        const response = await this.context.store.dispatch(request({ path: '/user/me/' }));
        this.originalUser = _.cloneDeep(response);
        this.context.store.dispatch([
            setSelectedItems(
                response.city ? [response.city.id] : [],
                'city',
                this.props.store.getIn(['cityTree', 'elementId']),
            ),
            setSelectedItems(
                response.city.region ? [response.city.region] : [],
                'region',
                this.props.store.getIn(['regionTree', 'elementId']),
            ),
        ]);
        this.setState(response);
    }

    render() {
        if (!this.props.store.getIn(['main', 'info']))
            return null;
        if (this.props.is_virtual) {

            return <div>
                {this.props.active
                    ? <div>
                        <div
                            style={{
                                float: 'right',
                                fontSize: '.9em',
                                width: 'calc(50% - 1em)',
                                margin: '.5em',
                            }}>
                            <Tree
                                store={this.props.store.get('regionTree')}
                                readonly
                                resource='region'
                                itemLabel={object => object.name}
                                multiSelection={false}
                                combobox
                                label={<span><span style={{ color: styles.alertColor }}>* </span>{window.gettext('Region')}</span>}
                            />
                        </div>
                        <div
                            style={{
                                float: 'right',
                                fontSize: '.9em',
                                width: 'calc(50% - 1em)',
                                margin: '.5em',
                            }}>
                            <Tree
                                store={this.props.store.get('cityTree')}
                                readonly
                                resource='city'
                                itemLabel={object => object.name}
                                multiSelection={false}
                                combobox
                                label={<span><span style={{ color: styles.alertColor }}>* </span>{window.gettext('City')}</span>}
                                filter={this.cityTreeFilterSelector(this.props.store.get('regionTree'))}
                            />
                        </div>
                        <div style={{ float: 'right', width: 'calc(100% - 1em)', marginLeft: '.5em', marginRight: '.5em' }}>
                            <TextField
                                textarea
                                required
                                fullwidth
                                autoCorrect='off'
                                autoCapitalize='none'
                                rows='1'
                                label='مدرسه'
                                value={(this.state.address || '').persian()}
                                onChange={({ target: { value } }) => this.setState({ address: value.persian() })}
                            />
                        </div>
                    </div>
                    : <div> 
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('City')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.city_display || '-'}</span>
                        <br /> 
                        <span style={{ color: '#9a9a9a' }}>مدرسه:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.address || '-'}</span>
                    </div>
                }
                <div style={{ float: 'right', marginRight: '.5em', color: styles.alertColor }}>
                       اطلاعات را به صورت کامل وارد کنید  
                </div>
                {this.props.active
                    ? <div>
                        <button
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginLeft: '.5em',
                            }}
                            onClick={async () => {
                                if (
                                    !this.state.address ||
                                    this.props.store.getIn(['cityTree', 'selected']).size === 0
                                ) {
                                    alert(window.gettext('Incomplete data'));
                                    return;
                                }
                                if (
                                    this.state.address !== this.originalUser.address ||
                                    this.props.store.getIn(['cityTree', 'selected']).keySeq().first() != this.originalUser.city.id
                                )
                                {
                                    let confirmStat = window.confirm(window.gettext('Do you want to update your information?')) ;
                                    if (confirmStat) {
                                        await this.context.store.dispatch(request({
                                            path: `/user/${this.originalUser.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                address: this.state.address,
                                                city: { id: this.props.store.getIn(['cityTree', 'selected']).keySeq().first() },
                                            },
                                        }));
                                    }
                                }
                                this.context.store.dispatch([
                                    actions.setInfo({
                                        address: this.state.address,
                                        city: this.props.store.getIn(['cityTree', 'selected']).keySeq().first(),
                                        city_display: this.props.store.getIn(['cityTree', 'selected']).valueSeq().toArray()[0],
                                        region: this.props.store.getIn(['regionTree', 'selected']).keySeq().first(),
                                        region_display: this.props.store.getIn(['regionTree', 'selected']).valueSeq().toArray()[0],
                                    }),
                                    push({
                                        pathname: '/store/purchase/next/',
                                        query: this.props.location.query,
                                    }),
                                ]);
                            }}>
                            {window.gettext('Confirm')}
                        </button>
                    </div>
                    : null
                }
            </div>;

        }
        else {

            return <div>
                {this.props.active
                    ? <div>
                        <div
                            style={{
                                float: 'right',
                                fontSize: '.9em',
                                width: 'calc(50% - 1em)',
                                margin: '.5em',
                            }}>
                            <Tree
                                store={this.props.store.get('regionTree')}
                                readonly
                                resource='region'
                                itemLabel={object => object.name}
                                multiSelection={false}
                                combobox
                                label={<span><span style={{ color: styles.alertColor }}>* </span>{window.gettext('Region')}</span>}
                            />
                        </div>
                        <div
                            style={{
                                float: 'right',
                                fontSize: '.9em',
                                width: 'calc(50% - 1em)',
                                margin: '.5em',
                            }}>
                            <Tree
                                store={this.props.store.get('cityTree')}
                                readonly
                                resource='city'
                                itemLabel={object => object.name}
                                multiSelection={false}
                                combobox
                                label={<span><span style={{ color: styles.alertColor }}>* </span>{window.gettext('City')}</span>}
                                filter={this.cityTreeFilterSelector(this.props.store.get('regionTree'))}
                            />
                        </div>
                        <div style={{ clear: 'right', float: 'right', width: 'calc(50% - 1em)', marginLeft: '.5em', marginRight: '.5em', marginBottom: '-.5em' }}>
                            <TextField
                                rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                required
                                outlined
                                autoCorrect='off'
                                autoCapitalize='none'
                                label={window.gettext('Firstname')}
                                value={(this.state.firstname || '').persian()}
                                onChange={({ target: { value } }) => this.setState({ firstname: value.persian() })}
                            />
                        </div>
                        <div style={{ float: 'right', width: 'calc(50% - 1em)', marginLeft: '.5em', marginRight: '.5em', marginBottom: '-.5em' }}>
                            <TextField
                                rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                required
                                outlined
                                autoCorrect='off'
                                autoCapitalize='none'
                                label={window.gettext('Lastname')}
                                value={(this.state.lastname || '').persian()}
                                onChange={({ target: { value } }) => this.setState({ lastname: value.persian() })}
                            />
                        </div>
                        <div style={{ float: 'right', width: 'calc(50% - 1em)', marginLeft: '.5em', marginRight: '.5em', marginBottom: '-.5em' }}>
                            <TextField
                                rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                required
                                outlined
                                pattern={this.state.cellphoneValidator.source}
                                autoCorrect='off'
                                autoCapitalize='none'
                                label={window.gettext('Cell phone')}
                                value={(this.state.cell_phone || '').persian()}
                                onChange={({ target: { value } }) => {
                                    value = value.english();
                                    if (value.length > 0 && !value.match(cellphonePartialValidator))
                                        return;
                                    this.setState({ cell_phone: value });
                                }}
                                onFocus={() => this.setState({ cellphoneValidator: cellphonePartialValidator })}
                                onBlur={() => this.setState({ cellphoneValidator })}
                            />
                            <TextFieldHelperText persistent validationMsg>
                                {window.gettext('Cell phone should be 11 digits starting with 09.')}
                            </TextFieldHelperText>
                        </div>
                        <div style={{ float: 'right', width: 'calc(50% - 1em)', marginLeft: '.5em', marginRight: '.5em', marginBottom: '-.5em' }}>
                            <TextField
                                rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                outlined
                                autoCorrect='off'
                                autoCapitalize='none'
                                label={window.gettext('Phone')}
                                value={(this.state.phone || '').persian()}
                                onChange={({ target: { value } }) => {
                                    value = value.english();
                                    if (isNaN(Number(value)) && value.length > 0)
                                        return;
                                    if (Number.parseInt(value) < 0)
                                        return;
                                    this.setState({
                                        phone: isNaN(Number.parseInt(value)) ? '' : value,
                                    });
                                }}
                            />
                            <TextFieldHelperText persistent validationMsg>{window.gettext('Enter city code')}</TextFieldHelperText>
                        </div>
                        
                        <div style={{ float: 'right', clear: 'right', width: 'calc(50% - 1em)', marginLeft: '.5em', marginRight: '.5em', marginBottom: '-.5em' }}>
                            <TextField
                                rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                outlined
                                autoCorrect='off'
                                autoCapitalize='none'
                                label={window.gettext('Postal Code')}
                                value={(this.state.postal_code || '').persian()}
                                onChange={({ target: { value } }) => {
                                    value = value.english();
                                    if (isNaN(Number(value)) && value.length > 0)
                                        return;
                                    if (value.length > 10)
                                        return;
                                    if (Number.parseInt(value) < 0)
                                        return;
                                    this.setState({
                                        postal_code: isNaN(Number.parseInt(value)) ? '' : value,
                                    });
                                }}
                            />
                            
                            <TextFieldHelperText persistent validationMsg>
                                {window.gettext('Postal code should be 10 digits.')}
                            </TextFieldHelperText>
                            
                        </div>
                        
                        <div style={{ float: 'right', width: 'calc(100% - 1em)', marginLeft: '.5em', marginRight: '.5em' }}>
                            
                            <select onChange={(e)=>this.setState({representive_id: e.target.value })} value={this.state.representive_id || ''} style={{
                                width:'100%',
                                height: '2.4rem',
                                margin: '.5rem 0',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '.9rem',
                                fontWeight: '600',
                                color:'gray',
                                fontFamily: 'IRANSans',
                                borderColor:this.state.requireRepresentive?'red':'black'
                            }}>
                                <option value='' disabled={true}>انتخاب معرف*</option>
                                {this.state.representivates?.map(el=>(
                                    <option style={{}} value={el.id}>{el.title}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ float: 'right', width: 'calc(100% - 1em)', marginLeft: '.5em', marginRight: '.5em' }}>
                            <TextField
                                textarea
                                required
                                fullwidth
                                autoCorrect='off'
                                autoCapitalize='none'
                                rows='2'
                                label={window.gettext('Address')}
                                value={(this.state.address || '').persian()}
                                onChange={({ target: { value } }) => this.setState({ address: value.persian() })}
                            />
                        </div>
                    </div>
                    : <div>
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Firstname')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.firstname} {this.state.lastname}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Cell phone')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.cell_phone || '-'}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Phone')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.phone || '-'}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Region')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.region_display || '-'}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('City')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.city_display || '-'}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Postal Code')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.postal_code || '-'}</span>
                        <br />
                        <span style={{ color: '#9a9a9a' }}>{window.gettext('Address')}:</span>&nbsp;
                        <span style={{ color: '#2a2a2a' }}>{this.state.address || '-'}</span>
                    </div>
                }
                <div style={{ float: 'right', marginRight: '.5em', color: styles.alertColor }}>
                    * فیلد‌های ستاره‌دار اجباری هستند!
                </div>
                {this.props.active
                    ? <div>
                        <button
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginLeft: '.5em',
                            }}
                            onClick={async () => {
                                if(!this.state.representive_id)
                                        this.setState({requireRepresentive: true});
                                
                                if (
                                    !this.state.firstname ||
                                    !this.state.lastname ||
                                    (this.state.cell_phone || '').length < 11 ||
                                    (this.state.postal_code && this.state.postal_code.length < 10) ||
                                    this.props.addressRequired && !this.state.address ||
                                    this.props.store.getIn(['cityTree', 'selected']).size === 0 ||
                                    !this.state.representive_id

                                ) {
                                    alert(window.gettext('Incomplete data'));
                                    return;
                                }
                                if (
                                    this.state.cell_phone !== this.originalUser.cell_phone ||
                                    this.state.phone !== this.originalUser.phone ||
                                    this.state.postal_code !== this.originalUser.postal_code ||
                                    this.state.address !== this.originalUser.address ||
                                    this.props.store.getIn(['cityTree', 'selected']).keySeq().first() != this.originalUser.city.id
                                )
                                {
                                    let confirmStatus = window.confirm(window.gettext('Do you want to update your information?')) ;
                                    if (confirmStatus) {
                                        await this.context.store.dispatch(request({
                                            path: `/user/${this.originalUser.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                cell_phone: this.state.cell_phone,
                                                phone: this.state.phone,
                                                postal_code: this.state.postal_code,
                                                address: this.state.address,
                                                city: { id: this.props.store.getIn(['cityTree', 'selected']).keySeq().first() },
                                            },
                                        }));
                                    }
                                }
                                this.context.store.dispatch([
                                    actions.setInfo({
                                        firstname: this.state.firstname,
                                        lastname: this.state.lastname,
                                        cell_phone: this.state.cell_phone,
                                        phone: this.state.phone,
                                        postal_code: this.state.postal_code,
                                        address: this.state.address,
                                        city: this.props.store.getIn(['cityTree', 'selected']).keySeq().first(),
                                        city_display: this.props.store.getIn(['cityTree', 'selected']).valueSeq().toArray()[0],
                                        region: this.props.store.getIn(['regionTree', 'selected']).keySeq().first(),
                                        region_display: this.props.store.getIn(['regionTree', 'selected']).valueSeq().toArray()[0],
                                        representive_id: this.state.representive_id
                                    }),
                                    push({
                                        pathname: '/store/purchase/next/',
                                        query: this.props.location.query,
                                    }),
                                ]);
                            }}>
                            {window.gettext('Confirm')}
                        </button>
                    </div>
                    : null
                }
            </div>;

        }

    }
}
